const VoteButton = () => {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="8" fill="#FD8533" />
      <path
        d="M13.3346 27.5H14.168V16.6667H13.3346C12.8926 16.6667 12.4687 16.8423 12.1561 17.1548C11.8436 17.4674 11.668 17.8913 11.668 18.3334V25.8334C11.668 26.2754 11.8436 26.6993 12.1561 27.0119C12.4687 27.3244 12.8926 27.5 13.3346 27.5ZM26.668 16.6667H20.8346L21.7696 13.86C21.8531 13.6095 21.8758 13.3428 21.8359 13.0818C21.7961 12.8208 21.6948 12.573 21.5404 12.3588C21.3861 12.1447 21.183 11.9702 20.948 11.8499C20.713 11.7295 20.4528 11.6668 20.1888 11.6667H20.0013L15.8346 16.1984V27.5H25.0013L28.2613 20.3367L28.3346 20V18.3334C28.3346 17.8913 28.159 17.4674 27.8465 17.1548C27.5339 16.8423 27.11 16.6667 26.668 16.6667Z"
        fill="white"
      />
    </svg>
  );
};

export default VoteButton;
